import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

import { accountSettingState } from './accountSettingState';
import { AccountSettingState } from '../types';

export const accountSettingSlice = createSlice({
  name: 'accountSettings',
  initialState: accountSettingState,
  reducers: {
    setAccountProperties: (
      state,
      action: PayloadAction<AccountSettingState['accountProperties']>,
    ) => {
      state.accountProperties = action.payload;
    },
    setDefaultUserPreferences: (
      state,
      action: PayloadAction<AccountSettingState['defaultUserPreferences']>,
    ) => {
      state.defaultUserPreferences = action.payload;
    },
    setVbusDevices: (
      state,
      action: PayloadAction<AccountSettingState['vbusDevices']>,
    ) => {
      state.vbusDevices = action.payload;
    },
    setReasonList: (
      state,
      action: PayloadAction<AccountSettingState['reasonList']>,
    ) => {
      state.reasonList = action.payload;
    },
    setHiddenReports: (
      state,
      action: PayloadAction<AccountSettingState['hiddenReports']>,
    ) => {
      state.hiddenReports = action.payload;
    },
  },
});

export const { actions: accountSettingActions } = accountSettingSlice;

export const selectAccountSettings = (state: RootState) =>
  state.accountSettings;

export const selectAccountProperties = createSelector(
  selectAccountSettings,
  accountSettings => accountSettings.accountProperties,
);

export const selectDefaultUserPreferences = createSelector(
  selectAccountSettings,
  accountSettings => accountSettings.defaultUserPreferences,
);

export const selectVbusDevices = createSelector(
  selectAccountSettings,
  accountSettings => accountSettings.vbusDevices,
);

export const selectReasonList = createSelector(
  selectAccountSettings,
  accountSettings => accountSettings.reasonList,
);

export const selectHiddenReports = createSelector(
  selectAccountSettings,
  accountSettings => accountSettings.hiddenReports,
);

export default accountSettingSlice.reducer;
